import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Select from "react-select";
import DataTable from "react-data-table-component";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { API_BASE_URL } from "../../../config";
import {
  statisticsAction,
  statisticsCloseAction,
} from "../../../actions/settingsAction";

const Add_department = (props) => {
  const { fixNavbar } = props;
  const history = useHistory();

  /* ================= STATE ================= */
  const [formData, setFormData] = useState({
    department_name: "",
    dept_head: "",
  });

  const [user, setUser] = useState({
    department_name: "",
    dept_head: "",
    department_id: "",
  });

  const [data, setData] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
const [rowsPerPage, setRowsPerPage] = useState(10);

  const emptyMenu = {
    department_name: "",
    dept_head: "",
    department_id: "",
  };

  /* ================= FETCH DATA ================= */
  useEffect(() => {
    fetchDepartments();
    fetchEmployees();
  }, []);

  const fetchDepartments = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_BASE_URL}/department_list`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      });
      setData(res.data.data.leave_type || []);
    } catch (err) {
      toast.error("Failed to load departments");
    } finally {
      setLoading(false);
    }
  };

  const fetchEmployees = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/all_employees`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      });
      setEmployees(res.data.data.all_employee || []);
    } catch (err) {
      toast.error("Failed to load employees");
    }
  };

  /* ================= HANDLERS ================= */
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSelectChange = (selected) => {
    setFormData({ ...formData, dept_head: selected?.value || "" });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(
        `${API_BASE_URL}/add_department`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );

      if (res.data.status === "success") {
        toast.success(res.data.message);
        fetchDepartments();
        setFormData({ department_name: "", dept_head: "" });
      } else {
        toast.error(res.data.message);
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Error occurred");
    }
  };

  const handleUpdate = async (department_id) => {
    try {
      const res = await axios.get(
        `${API_BASE_URL}/showdepartment/${department_id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );
      setUser(res.data);
    } catch (err) {
      toast.error("Failed to fetch department");
    }
  };

const handleEditSubmit = async (e) => {
  e.preventDefault();
  try {
    const res = await axios.post(
      `${API_BASE_URL}/updatedepartment`,
      {
        department_id: user.department_id,
        department_name: user.department_name,
        dept_head: user.dept_head,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      }
    );

    if (res.data.status === "success") {
      toast.success(res.data.message);

      // ✅ reload table data only
      await fetchDepartments();

      // ✅ close modal
      window.$("#exampleEditModal").modal("hide");

      // ✅ reset form
      setUser({
        department_id: "",
        department_name: "",
        dept_head: "",
      });
    } else {
      toast.error(res.data.message);
    }
  } catch (err) {
    toast.error("Update failed");
  }
};

  /* ================= FILTER ================= */
  const filteredData = data.filter((item) =>
    `${item.department_name}${item.name}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  /* ================= DATATABLE COLUMNS ================= */
  const columns = [
    
   
    {
      name: "Department Name",
      selector: (row) => row.department_name,
      sortable: true,
    },
    {
      name: "Department Head",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "Count",
      selector: (row) => row.count,
      center: true,
    },
    {
      name: "Action",
      cell: (row) => (
        <button
          className="btn btn-sm btn-icon"
          data-toggle="modal"
          data-target="#exampleEditModal"
          onClick={() => {
            handleUpdate(row.department_id);
            setUser(emptyMenu);
          }}
        >
          <i className="fa fa-edit" />
        </button>
      ),
      button: true,
    },
  ];

  /* ================= RENDER ================= */
  return (
    <>
	 <ToastContainer position="bottom-right" />

      <div className={`section-body ${fixNavbar ? "marginTop" : ""}`}>
        <div className="container-fluid px-4 px-lg-5">

          {/* ===== ADD DEPARTMENT FORM ===== */}
          <div className="card mb-4">
            <div className="card-header">
              <h3 className="card-title">Add Department</h3>
            </div>
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row align-items-end">

                  <div className="col-md-4">
                    <label>Department Name</label>
                    <input
                      type="text"
                      className="form-control required-input"
                      name="department_name"
					    placeholder="Department "
                      value={formData.department_name}
                      onChange={handleChange}
                      
                    />
                  </div>

                  <div className="col-md-4">
                    <label>Department Head</label>
                    <Select classNames={{
    control: () => "required-select required-tooltip"
  }}
                      options={employees}
                      onChange={handleSelectChange}
                      placeholder="Department Head"
                    />
                  </div>

                  <div className="col-md-2">
                    <button className="btn btn-primary w-100">
                      Add
                    </button>
                  </div>

                </div>
              </form>
            </div>
          </div>

          {/* ===== DEPARTMENT LIST ===== */}
          <div className="card">
            <div className="card-header d-flex justify-content-between align-items-center">
              <h3 className="card-title" style={{ color: "#e96827" }}>
                Department List
              </h3>
              <input
                type="text"
                className="form-control form-control-sm"
                style={{ width: "200px" }}
                placeholder="Search"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            <div className="card-body">
            <DataTable
  columns={columns}
  data={filteredData}
  pagination
  paginationPerPage={rowsPerPage}
  paginationRowsPerPageOptions={[10,25,50,100]}
  onChangeRowsPerPage={(newPerPage) => {
    setRowsPerPage(newPerPage);
  }}
  highlightOnHover
  striped
  responsive
/>

            </div>
          </div>

        </div>
      </div>

      {/* ===== EDIT MODAL ===== */}
      <div
        className="modal fade"
        id="exampleEditModal"
        tabIndex="-1"
        role="dialog"
      >
        <form onSubmit={handleEditSubmit}>
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5>Edit Department</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                >
                  ×
                </button>
              </div>
              <div className="modal-body">
                <input
                  type="text"
                  className="form-control mb-2"
                  value={user.department_name}
                  onChange={(e) =>
                    setUser({ ...user, department_name: e.target.value })
                  }
                />

                <Select
                  options={employees}
                  value={
                    employees.find(
                      (e) => e.value === user.dept_head
                    ) || null
                  }
                  onChange={(selected) =>
                    setUser({ ...user, dept_head: selected.value })
                  }
                />
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" data-dismiss="modal">
                  Close
                </button>
                <button className="btn btn-primary">
                  Save
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  fixNavbar: state.settings.isFixNavbar,
});

export default connect(mapStateToProps, {
  statisticsAction,
  statisticsCloseAction,
})(Add_department);
